var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSettingsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 16.69V12H23.3099L19.9999 8.69L16.6899 12H11.9999V16.69L8.68994 20L11.9999 23.31V28H16.6899L19.9999 31.31L23.3099 28H27.9999V23.31L31.3099 20L27.9999 16.69ZM25.9999 22.48V26H22.4799L19.9999 28.48L17.5199 26H13.9999V22.48L11.5199 20L13.9999 17.52V14H17.5199L19.9999 11.52L22.4799 14H25.9999V17.52L28.4799 20L25.9999 22.48ZM19.9999 14.5C16.9699 14.5 14.4999 16.97 14.4999 20C14.4999 23.03 16.9699 25.5 19.9999 25.5C23.0299 25.5 25.4999 23.03 25.4999 20C25.4999 16.97 23.0299 14.5 19.9999 14.5ZM19.9999 23.5C18.0699 23.5 16.4999 21.93 16.4999 20C16.4999 18.07 18.0699 16.5 19.9999 16.5C21.9299 16.5 23.4999 18.07 23.4999 20C23.4999 21.93 21.9299 23.5 19.9999 23.5Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22C21.1046 22 22 21.1046 22 20C22 18.8954 21.1046 18 20 18C18.8954 18 18 18.8954 18 20C18 21.1046 18.8954 22 20 22Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSettingsCircle);
export default __webpack_public_path__ + "static/media/ic_settings_circle.5884df2b658c2a9c74ae6df8ee7b7be5.svg";
export { ForwardRef as ReactComponent };